$ = require('jquery')

module.exports =
	init: (payload) ->
		{$target} = payload

		$target

			# amount of stars in form review with changing text from data-stars-text
			.on('click', '.stars-input > span', (event) ->
				$(this).addClass('stars__icon--full is-active').removeClass('icon--star-o').prevAll().not('.is-active').addClass('stars__icon--full is-active')
				$(this).nextAll().removeClass('is-active stars__icon--full')
				$('.f-review__stars-text').text($(this).data('stars-text'))
				$('.f-review__inp').val($(this).data('stars-text'))
			)





// WEBPACK FOOTER //
// ./src/js/components/stars.coffee